import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('entityDescription', [
    'cachedEntityDescriptions',
    'selectedEntityDescription',
  ]),
}

export const Methods = mapActions('entityDescription', [
  'selectEntityDescription',
  'entityDescriptionByName',
  'fetchEntityDescriptions',
  'updateEntityDescription',
])
